import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Button, Form, Modal, Spinner, Dropdown } from 'react-bootstrap';
import $ from 'jquery';
import 'jquery-confirm';
import { AppContext } from '../App';


export const Staff = () => {
	const { accessToken, user, setAuthForm, link, staffs, setStaffs, getStaffsLoad, staffTypes, postCall } = useContext(AppContext);
	const [staffAddModel, setStaffAddModel] = useState(false);
	useEffect(() => {
		if (!staffAddModel) {
			setInvalidEmail();
			setInvalidUsername();
		}
	}, [staffAddModel]);
	const [fNameError, setFnameError] = useState(false);
	const [staffTypeError, setStaffTypeError] = useState(false);
	const [usernameError, setUsernameError] = useState(false);
	const [passError, setPassError] = useState(false);
	const [cpassError, setCpassError] = useState(false);
	const [passEqualError, setPassEqualError] = useState(false);
	const [emailError, setEmailError] = useState(false);
	const [staffAddLoad, setStaffAddLoad] = useState(false);
	const [invalidUsername, setInvalidUsername] = useState();
	const [checkUsernameLoad, setCheckUsernameLoad] = useState(false);
	const checkUsername = (usr) => {
		if (usr !== "") {
			setCheckUsernameLoad(true);
			postCall('api/pnp/get/username/', {
				username: usr,
			}).then((response) => {
				setCheckUsernameLoad(false);
				setInvalidUsername(response.data);
			}).catch((err) => {
				setCheckUsernameLoad(false);
			});
		} else {
			setInvalidUsername();
		}
	}
	const [invalidEmail, setInvalidEmail] = useState();
	const [checkEmailLoad, setCheckEmailLoad] = useState(false);
	const checkEmail = (mail) => {
		if (mail !== "") {
			setCheckEmailLoad(true);
			postCall('api/pnp/get/emailid/', {
				email: mail,
			}).then((response) => {
				setCheckEmailLoad(false);
				setInvalidEmail(response.data);
			}).catch((err) => {
				setCheckEmailLoad(false);
			});
		} else {
			setInvalidEmail();
		}
	}
	const addStaff = (e) => {
		e.preventDefault();
		let first_name = e.target.first_name.value;
		let last_name = e.target.last_name.value;
		let staff_type = e.target.type.value;
		let status = e.target.visibility.checked;
		let username = e.target.username.value;
		let password = e.target.password.value;
		let password2 = e.target.password2.value;
		let email = e.target.email.value;


		if (first_name === "") {
			setFnameError(true);
			setTimeout(() => { setFnameError(false) }, 5000);
		}
		if (staff_type === "") {
			setStaffTypeError(true);
			setTimeout(() => { setStaffTypeError(false) }, 5000);
		}
		if (username === "") {
			setUsernameError(true);
			setTimeout(() => { setUsernameError(false) }, 5000);
		}
		if (password === "") {
			setPassError(true);
			setTimeout(() => { setPassError(false) }, 5000);
		}
		if (password2 === "") {
			setCpassError(true);
			setTimeout(() => { setCpassError(false) }, 5000);
		}
		if (password !== "" && password2 !== "" && password !== password2) {
			setPassEqualError(true);
			setTimeout(() => { setPassEqualError(false) }, 5000);
		}
		if (email === "") {
			setEmailError(true);
			setTimeout(() => { setEmailError(false) }, 5000)
		}
		if (first_name !== "" && staff_type !== "" && username !== "" && password !== "" && password2 !== "" && password === password2 && email !== "" && !invalidUsername && !invalidEmail) {
			setStaffAddLoad(true);
			postCall('api/pnp/add/staff/', {
				first_name: first_name,
				last_name: last_name,
				staff_type: staff_type,
				status: status,
				username: username,
				email: email,
				password: password,
			}).then((response) => {
				setStaffAddLoad(false);
				setStaffs(response.data);
				setStaffAddModel(false);
			}).catch((err) => {
				setStaffAddLoad(false);
			});
		}

	}
	const [changePasswordModel, setChangePasswordModel] = useState(false);
	const [staffId, setStaffId] = useState();
	const [npassError, setNpassError] = useState(false);
	const [ncpassError, setNcpassError] = useState(false);
	const [npassEqualError, setNpassEqualError] = useState(false);
	const [changePassLoad, setChangePassLoad] = useState(false);
	const [alertPassChange, setAlertPassChange] = useState('default');
	const changePassword = (e) => {
		e.preventDefault();
		let pass = e.target.password.value;
		let cpass = e.target.password2.value;
		if (pass === "") {
			setNpassError(true);
			setTimeout(() => { setNpassError(false) }, 5000);
		}
		if (cpass === "") {
			setNcpassError(true);
			setTimeout(() => { setNcpassError(false) }, 5000);
		}
		if (pass !== "" && cpass !== "" && pass !== cpass) {
			setNpassEqualError(true);
			setTimeout(() => { setNpassEqualError(false) }, 5000);
		}
		if (pass !== "" && cpass !== "" && pass === cpass) {
			setChangePassLoad(true);
			postCall('api/pnp/change/staff/password/', {
				staff_id: staffId,
				password: pass,
			}).then((response) => {
				setChangePassLoad(false);
				setAlertPassChange('sucess');
				setTimeout(() => {
					setAlertPassChange('default');
					setChangePasswordModel(false);
				}, 3000);
			}).catch((err) => {
				setChangePassLoad(false);
				setAlertPassChange('error');
				setTimeout(() => {
					setAlertPassChange('default');
				}, 3000);
			});
		}
	}

	const [changeStaffStatusChangeLoad, setStaffStatusChangeLoad] = useState(false);
	const changeStaffStatus = (sid, status) => {
		setStaffStatusChangeLoad(true);
		postCall('api/pnp/edit/staff/status/', {
			staff_id: sid,
			status: status,
		}).then((response) => {
			setStaffStatusChangeLoad(false);
			setStaffs(response.data);
		}).catch((err) => {
			setStaffStatusChangeLoad(false);
		});
	}
	const [staffEditModel, setStaffEditModel] = useState(false);
	const [editStaffId, setEditStaffId] = useState();
	const [staffEditFname, setStaffEditFname] = useState('');
	const [staffEditLname, setStaffEditLname] = useState('');
	const [stffEditDesig, setStaffEditDesig] = useState('');
	const updateStaff = (e) => {
		e.preventDefault();
		let first_name = e.target.first_name.value;
		let last_name = e.target.last_name.value;
		let staff_type = e.target.type.value;
		if (first_name === "") {
			setFnameError(true);
			setTimeout(() => { setFnameError(false) }, 5000);
		}
		if (staff_type === "") {
			setStaffTypeError(true);
			setTimeout(() => { setStaffTypeError(false) }, 5000);
		}
		if (first_name !== "" && staff_type !== "") {
			setStaffAddLoad(true);
			postCall('api/pnp/edit/staff/', {
				staff_id: editStaffId,
				first_name: first_name,
				last_name: last_name,
				staff_type: staff_type,
			}).then((response) => {
				setStaffAddLoad(false);
				setStaffs(response.data);
				setStaffEditModel(false);
			}).catch((err) => {
				setStaffAddLoad(false);
			});
		}

	}
	const disablePermenently = (sid) => {
		setStaffStatusChangeLoad(true);
		postCall('api/pnp/edit/staff/permanently/status/', {
			staff_id: sid,
			status: true,
		}).then((response) => {
			setStaffStatusChangeLoad(false);
			setStaffs(response.data);
			setEditStaffId();
		}).catch((err) => {
			setStaffStatusChangeLoad(false);
		});
	}
	return (
		<div className="container-fluid" >
			<Row className='bgp br-3 mb-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="flex-wrap align-items-center justify-content-between p-2" >
					<span className="f16 tp2 text-white" >{getStaffsLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : (
						staffs !== undefined && staffs.max !== null && staffs.available !== null ? (
							`Available : ${parseInt(staffs.max) - parseInt(staffs.available)} / ${staffs.max}`
						) : ''
					)}</span>
					{
						user !== undefined ? (
							(user.type === 'admin') || ((user.permission !== undefined) && (user.permission.staff !== undefined && user.permission.staff.A)) ? (
								staffs !== undefined && staffs.available !== null && staffs.available > 0 ? (
									<Button onClick={() => { setStaffAddModel(true) }} className="btn-t1" ><i className="bi bi-plus-circle"></i> Add new</Button>
								) : (<span className='text-muted px-2' >Limit Reached</span>)
							) : ''
						) : ''
					}
				</Col>
			</Row>
			<Row>
				{
					staffs !== undefined && staffs.staff !== undefined && Object.keys(staffs.staff).length > 0 ? (
						Object.keys(staffs.staff).map((staff, staff_i) => (
							<Col xs="12" sm="12" md="12" lg="12" className={`closed-item bgs1 mx-0 mb-1 bdr2 br-3 py-2 flex-wrap align-items-center justify-content-between ${staffs.staff[staff].permanent ? 'disabled' : ''}`} key={`staff_${staff_i}`} >
								<span className="f16 tp2" >{`${staffs.staff[staff].first_name} ${staffs.staff[staff].last_name}`}, ( Username : {staffs.staff[staff].username} ) - {staffs.staff[staff].designation}</span>
								<div className="flex-wrap align-items-center justify-content-end gap-2" >
									{
										staffId !== undefined && staffId === staffs.staff[staff].staff_id && changeStaffStatusChangeLoad ? (
											<Spinner animation="border" size="sm" />
										) : ''
									}

									{
										user !== undefined ? (
											(user.type === 'admin') || ((user.permission !== undefined) && (user.permission.staff !== undefined && user.permission.staff.A)) ? (
												staffs.staff[staff].permanent ? (
													<span className='text-danger' >Permanently Disabled</span>
												) : (
													<Dropdown menuRole >
														<Dropdown.Toggle variant="light" size="sm" className="br-4" ><i class="bi bi-three-dots-vertical"></i></Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item onClick={() => {
																setStaffEditModel(true);
																setEditStaffId(staff);
																setStaffEditFname(staffs.staff[staff].first_name);
																setStaffEditLname(staffs.staff[staff].last_name);
																setStaffEditDesig(staffs.staff[staff].designation);
															}} ><i className="bi bi-pencil-square"></i> Edit</Dropdown.Item>
															<Dropdown.Item onClick={() => {
																setStaffId(staffs.staff[staff].staff_id);
																setChangePasswordModel(true);
															}} ><i className="bi bi-lock"></i> Change password</Dropdown.Item>
															{
																staffs.staff[staff].status ? (
																	<Dropdown.Item onClick={() => {
																		changeStaffStatus(staff, false);
																		setStaffId(staffs.staff[staff].staff_id);
																	}} className='text-danger' ><i className="bi bi-eye-slash"></i> Disable</Dropdown.Item>

																) : (
																	<Dropdown.Item onClick={() => {
																		changeStaffStatus(staff, true);
																		setStaffId(staffs.staff[staff].staff_id);
																	}} className='text-success' ><i className="bi bi-eye"></i> Enable</Dropdown.Item>
																)
															}
															<Dropdown.Item onClick={() => {
																$.confirm({
																	title: 'This action cannot be undone!',
																	type: 'orange',
																	content: 'Are you sure you want to permanently disable this staff? ',
																	buttons: {
																		cancel: function () {
																		},
																		confirm: {
																			text: 'YES',
																			btnClass: 'btn-blue', // Apply the green class
																			action: function () {
																				setStaffId(staffs.staff[staff].staff_id);
																				disablePermenently(staffs.staff[staff].staff_id);
																			}
																		}
																	}
																})
															}} className='text-danger' ><i className="bi bi-exclamation-triangle-fill"></i> Permanently Disable</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												)
											) : ''
										) : ''
									}
								</div>
							</Col >
						))
					) : ''
				}
			</Row >
			<Modal size="xl" show={staffAddModel} backdrop="static" onHide={() => { setStaffAddModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Add staff</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addStaff} >
						<Form.Group className="mb-3">
							<Form.Label>First name {fNameError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Row>
								<Col xs={12} sm={12} md={6} >
									<Form.Control type="text" name="first_name" className="shadow-none br-2" placeholder="First name" />
								</Col>
								<Col xs={12} sm={12} md={6} >
									<Form.Control type="text" name="last_name" className="shadow-none br-2" placeholder="Last name" />
								</Col>
							</Row>
						</Form.Group>
						<Form.Group className="mb-3">
							<Row>
								<Col xs={12} sm={12} md={6} >
									<Form.Label>Type / Designation {staffTypeError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
									<Form.Select name="type" className="shadow-none br-2">
										{
											staffTypes !== undefined && Object.keys(staffTypes).length > 0 ? (
												Object.keys(staffTypes).map((stf, stf_i) => (
													<option value={staffTypes[stf].id} key={`stf_${stf_i}`} >{stf}</option>
												))
											) : ''
										}
									</Form.Select>
								</Col>
								<Col xs={12} sm={12} md={6} >
									<Form.Label>Enable staff login</Form.Label>
									<Form.Check type="checkbox" name="visibility" className="shadow-none br-2 form-control bdr-none" defaultChecked={true} label="Enable" />
								</Col>
							</Row>
						</Form.Group>
						<Form.Group className="mb-3">
							<Row>
								<Col xs={12} sm={12} md={6} >
									<Form.Label>Username
										{usernameError ? (<span className="error-message" >This field is required</span>) : ''}
										{
											checkUsernameLoad ? (
												<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
											) : (
												invalidUsername !== undefined ? (
													invalidUsername ? (
														<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Already taken</span>
													) : (
														<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
													)
												) : ''
											)
										}
									</Form.Label>
									<Form.Control onChange={(e) => { e.target.value = e.target.value.toLowerCase().replace(/[^a-z0-9]/g, '') }} onBlur={(e) => { checkUsername(e.target.value) }} type="text" name="username" className="shadow-none br-2" placeholder="Username" />
								</Col>
								<Col xs={12} sm={12} md={6} >
									<Form.Label>Email id
										{emailError ? (<span className="error-message" >This field is required</span>) : ''}
										{
											checkEmailLoad ? (
												<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
											) : (
												invalidEmail !== undefined ? (
													invalidEmail ? (
														<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Already taken</span>
													) : (
														<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
													)
												) : ''
											)
										}
									</Form.Label>
									<Form.Control onBlur={(e) => { checkEmail(e.target.value) }} type="email" name="email" className="shadow-none br-2" placeholder="Email id" />
								</Col>
							</Row>
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Password {passError ? (<span className="error-message" >This field is required</span>) : ''} {passEqualError ? (<span className="error-message" >Password and Confirm password do not mach</span>) : ''}</Form.Label>
							<Form.Control type="password" name="password" className="shadow-none br-2" placeholder="Password" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Confirm Password {cpassError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control type="password" name="password2" className="shadow-none br-2" placeholder="Confirm Password" />
						</Form.Group>
						<div className="d-grid">
							{
								staffAddLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1 br-2"><i className="bi bi-save"></i> SAVE</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer>

				</Modal.Footer>
			</Modal>

			<Modal size="lg" show={staffEditModel} backdrop="static" onHide={() => { setStaffEditModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Update staff details</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={updateStaff} >
						<Form.Group className="mb-3">
							<Form.Label>First name {fNameError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control type="text" name="first_name" defaultValue={staffEditFname} className="shadow-none br-2" placeholder="First name" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Last Name</Form.Label>
							<Form.Control type="text" name="last_name" defaultValue={staffEditLname} className="shadow-none br-2" placeholder="Last name" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Type / Designation {staffTypeError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Select name="type" className="shadow-none br-2">
								{
									staffTypes !== undefined && Object.keys(staffTypes).length > 0 ? (
										Object.keys(staffTypes).map((stf, stf_i) => (
											stffEditDesig !== undefined ? (
												stffEditDesig === stf ? (
													<option value={staffTypes[stf].id} key={`stf_${stf_i}`} selected>{stf}</option>
												) : (
													<option value={staffTypes[stf].id} key={`stf_${stf_i}`} >{stf}</option>
												)
											) : ''
										))
									) : ''
								}
							</Form.Select>
						</Form.Group>
						<div className="d-grid">
							{
								staffAddLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1 br-2"><i className="bi bi-save"></i> Update</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer>

				</Modal.Footer>
			</Modal>

			<Modal size="xl" show={changePasswordModel} backdrop="static" onHide={() => { setChangePasswordModel(false) }}>
				<Modal.Header closeButton>
					{
						alertPassChange !== undefined ? (
							alertPassChange === 'default' ? (
								'Change password'
							) : alertPassChange === 'error' ? (
								<span className='error-alert'>Sothing went wrong</span>
							) : alertPassChange === 'sucess' ? (
								<span className="sucess-alert">Sucess</span>
							) : ''
						) : 'Change password'
					}
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={changePassword} >
						<Form.Group className="mb-3">
							<Form.Label>New Password {npassError ? (<span className="error-message" >This field is required</span>) : ''} {npassEqualError ? (<span className="error-message" >Password and Confirm password do not mach</span>) : ''}</Form.Label>
							<Form.Control type="password" name="password" className="shadow-none br-2" placeholder="New Password" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Confirm Password {ncpassError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control type="password" name="password2" className="shadow-none br-2" placeholder="Confirm Password" />
						</Form.Group>
						<div className="d-grid">
							{
								changePassLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1 br-2"><i className="bi bi-save"></i> SAVE</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		</div >
	)
}